import AccountLendingInterestSettings from "@/models/Accounts/LendingAccounts/Ledgers/Settings/LendingInterest/AccountLendingInterestSettings";
import InterestRateType from "@/models/Products/InterestRateType";
import BaseUpdateAccountSettings from "@/models/Accounts/Shared/BaseUpdateAccountSettings";

export default class UpdateAccountLendingInterestSettingsRequest extends BaseUpdateAccountSettings {
    enabled: boolean = false;
    rateType: InterestRateType = InterestRateType.Fixed;
    rateValue: number = 0;
    rateSourceId: string;

    public constructor(settings: AccountLendingInterestSettings, updatedAt: Date) {
        super(updatedAt);
        this.enabled = settings.enabled;
        this.rateType = settings.rateType;
        this.rateValue = settings.rateValue;
        this.rateValue = +this.rateValue;
        this.rateSourceId = settings.rateSourceId;
    }
}